import { z } from 'zod';
import '@apexdesigner/schema-tools';

export const roleInfo = z
  .object({
    name: z.string().nullable().optional().describe('Role name'),

    displayName: z
      .string()
      .nullable()
      .optional()
      .describe('Human-readable label'),
  })
  .describe('Summary information about a role for assignment dropdowns.')
  .as('RoleInfo', { embedded: true });

export { roleInfo as roleInfoSchema };
